import Region, { getStringValue } from '@/utils/Region';
import Video from '@/data/Video';

export default class VideoPriorityHelper {

  public static defaultPrio = 10000000;

  private mainPrefix = 'main-prio-';
  private regionMainPrefix: string | undefined = undefined;
  private channelPrefix: string | undefined = undefined;
  private regionChannelPrefix: string | undefined = undefined;

  private channelAndRegionInc = 0;
  private channelAndNoRegionInc = 1000000;
  private noChannelAndRegionInc = 2000000;
  private noChannelAndNoRegionInc = 3000000;

  constructor(region: Region | undefined, channelName: string | undefined) {

    if(channelName) {
      this.channelPrefix = `${channelName.toLowerCase()}-prio-`;
    }
    if(region) {
      this.regionMainPrefix = `${getStringValue(region).toLowerCase()}-${this.mainPrefix}`;
    }
    if(region && channelName) {
      this.regionChannelPrefix = `${getStringValue(region).toLowerCase()}-${this.channelPrefix}`;
    }
  }

  public extractAndSetPrio(video: Video) {
    const prio = this.extractPrio(video);
    video.priority = prio;
  }

  public extractPrio(video: Video): number {
    
    if(!video.keywords) return VideoPriorityHelper.defaultPrio;
    
    let mainPrio = VideoPriorityHelper.defaultPrio;
    let channelPrio = VideoPriorityHelper.defaultPrio;
    let regionMainPrio = VideoPriorityHelper.defaultPrio;
    let regionChannelPrio = VideoPriorityHelper.defaultPrio;

    for(const keyword of video.keywords) {
      const keyWordLowerCase = keyword.toLowerCase();
      let prio = this._extractPrio(keyWordLowerCase, this.mainPrefix);
      if(prio < mainPrio) mainPrio = prio + this.noChannelAndNoRegionInc;

      if(this.regionMainPrefix) {
        prio = this._extractPrio(keyWordLowerCase, this.regionMainPrefix);
        if(prio < regionMainPrio) regionMainPrio = prio + this.noChannelAndRegionInc;
      }
      if(this.channelPrefix) {
        prio = this._extractPrio(keyWordLowerCase, this.channelPrefix);
        if(prio < channelPrio) channelPrio = prio + this.channelAndNoRegionInc;
      }
      if(this.regionChannelPrefix) {
        prio = this._extractPrio(keyWordLowerCase, this.regionChannelPrefix);
        if(prio < regionChannelPrio) regionChannelPrio = prio + this.channelAndRegionInc;
      }      
    }

    if(regionChannelPrio != VideoPriorityHelper.defaultPrio) return regionChannelPrio;
		else if(channelPrio != VideoPriorityHelper.defaultPrio) return channelPrio;
		else if(regionMainPrio != VideoPriorityHelper.defaultPrio) return regionMainPrio;
		return mainPrio;
  }

  private _extractPrio(keyword: string, prefix: string): number {
    if(!keyword || !prefix || !keyword.startsWith(prefix)) {
      return VideoPriorityHelper.defaultPrio;
    }
    return this.__extractPrio(keyword.replace(prefix, ''))
  }

  private __extractPrio(prio: string): number {
    const prioInt = parseInt(prio);
    return isNaN(prioInt) ? VideoPriorityHelper.defaultPrio : prioInt;
  }
}